import React ,{ useRef, useEffect, useState,useMemo } from 'react';

import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useNavigate } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Map, {Marker,Popup,Source, Layer,
    NavigationControl,
    FullscreenControl,
    ScaleControl,
    GeolocateControl} from 'react-map-gl';
import axios from "axios";
import { useForm } from "react-hook-form";
import Geocode from "react-geocode";

import countries from '../information/countryNames.json'    
import 'mapbox-gl/dist/mapbox-gl.css';
import './Organizations.scss'
const MAPBOX_TOKEN ='pk.eyJ1Ijoic3R1ZGlncmFkIiwiYSI6ImNsZ25vN3JsazBoazUzbG9ldGlyYnZ0eGMifQ.dJHZGOO-SlBXr70pSXZ3iw';
const GTOKEN = 'AIzaSyClEBPiWhX_H9OX8ZvQ0bw5HtOxxRtGm9c';
const SERVER = `https://volunteer-server.onrender.com`
// const SERVER = `http://localhost:8800`
function Organizations() {
    Geocode.setApiKey(GTOKEN);
    Geocode.setLanguage("ua");
    const navigate = useNavigate();
    const [selectValue,setValue] = useState('')
    const [popupInfo, setPopupInfo] = useState(null);
    const [data, setData] = useState([]);
    const [inp, setInp] = useState("");
    const [location, setLocation] = useState("");
    const [country, setCountry] = useState("");
    const [newMarkers,setMarkes] = useState([]);
    const [org_type,setOrgType] = useState("")
    const [title,setTitle] = useState('')
    const [info,setInfo] = useState('')
    const [mimeType,setMimeType] = useState("")
    const { register, handleSubmit } = useForm();
const [image,setImage] = useState("")
    const[addr,setLocationAddr]= useState('')
    const mapRef = useRef();
    const [error,serErr] = useState(true)
 


    const setPoint = (e) =>{
      setMarkes([{long :e.lngLat.lng,lat : e.lngLat.lat}])

    };

    useEffect(() => {
        getAddress();
     }, [newMarkers]);


     const onSubmit = async (data) => {
      console.log(newMarkers[0].long)
      console.log(newMarkers[0].lat)
      const formData = new FormData();
      formData.append("file", data.file[0]);
      formData.append("title",title)
      formData.append("location",location)
      formData.append("description",info)
      formData.append("longitude",newMarkers[0].long)
      formData.append("latitude",newMarkers[0].lat)
      formData.append("ID_user",JSON.parse(localStorage.getItem("user")).ID_user)
      formData.append("country",selectValue)
      formData.append("org_type",org_type)
      const res = await fetch(`${SERVER}/api/add/organization`, {
          method: "POST",
          body: formData,
      }).then((res) => res.json()).catch((e)=>console.log(e));
      alert(JSON.stringify(`${res.message}, status: ${res.status}`));
      setInp("")
      setLocationAddr("")
      setMarkes([])
      setInfo("")
      setTitle("")
      setLocation("")
  };


    //  const addOrganization = async()=>{
    //   const data = {title,location,longitude:newMarkers[0].long,latitude:newMarkers[0].lat,description:info, user_id: JSON.parse(localStorage.getItem("user")).ID_user}
    //   try{
    //     const res = await axios.post(`https://volunteer-server.onrender.com/api/add/organization`,data)
    //     if(res.data.error){
    //       alert("Error")
    //     }
    //     alert(res.data.message)
    //     setInp("")
    //     setLocationAddr("")
    //     setMarkes([])
    //     setInfo("")
    //     setTitle("")
    //     setLocation("")
    //   }catch(e){
    //     console.log(e)
    //   }
   
    //  }
     const handleChange = (e) => {
      setValue(e.target.value);
    };
    const handleChangeOrg = (e) => {
      setOrgType(e.target.value);
    };
    const getAddress = ()=>{
        try{
        Geocode.fromLatLng(newMarkers[0].lat,newMarkers[0].long).then(
            (response) => {
              const address = response.results[0].formatted_address;
              setLocation(address)
            },
            (error) => {
              console.error(error);
            }
          );
        }catch(e){
            console.log(e)
        }
    }
    return (
        <div style={{height: '100%'}} class="row">
              <Container>
              <h1 class="text-center">New Organization</h1>
              <Row>
        <Col xs={7}>
        <Map
            ref={mapRef}
            initialViewState={{
            longitude:-100,
            latitude:40,
            zoom: 3.5
            }}
            style={{height: '100%',borderRadius: '5%',marginTop:'2%',  boxShadow: '1px 2px 9px #F4AAB9'}}
            mapStyle="mapbox://styles/mapbox/streets-v9"
            mapboxAccessToken= {MAPBOX_TOKEN}
            onDblClick={setPoint}
        >;
         {newMarkers ? newMarkers.map((elem)=>(
          <Marker 
                longitude={elem.long} 
                latitude={elem.lat} 
                anchor="bottom"  
                style={{cursor:'pointer'}}
                >
        </Marker>
          )) : null}
     

        <Container fluid="md">
        <Row>
        <Col xs={6} md={4}>
        <InputGroup className="mb-3" sty>
     <Form.Control
       placeholder="Пошук"
       aria-label=""
       aria-describedby="basic-addon1"
       onChange={async(event)=>{
         setInp(event.target.value)
         const res = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${inp}.json?access_token=pk.eyJ1Ijoic3R1ZGlncmFkIiwiYSI6ImNsZ25vN3JsazBoazUzbG9ldGlyYnZ0eGMifQ.dJHZGOO-SlBXr70pSXZ3iw`)
             console.log(res.data.features)
             setData(res.data.features)
       }}
       value={inp}
     />
   </InputGroup>
        </Col>
        
      </Row>
      <ListGroup  style={{fontSize: 'small',marginBottom:'0px'}}>
    {(inp || addr) && data.map((elem)=>(
        <Row style={{fontSize: 'small',marginBottom:'0px'}}>
          <Col xs={6} md={4}>
          <ListGroup.Item
       
          onClick={()=>{
            
            setLocation(elem.place_name)
            setInp("")
            setLocationAddr("")
            setMarkes([{long :elem.center[0],lat : elem.center[1]}])
            mapRef.current.flyTo({
                center: [elem.center[0], elem.center[1]], 
                duration: 2000,
                zoom: 10
            });
          }}
          style={{cursor:'pointer'}}
          >
            {elem.place_name}
            </ListGroup.Item>
            </Col>  
        
        </Row>
    ))}
    </ListGroup>
    </Container>



    <GeolocateControl position="top-right" />
    <FullscreenControl position="top-right" />
    <NavigationControl position="top-right" />
    <ScaleControl position="top-right"/>
  

    {/* {popupInfo && (
          <Popup
            anchor="top"
            longitude={Number(popupInfo.longitude)}
            latitude={Number(popupInfo.latitude)}
            onClose={() => setPopupInfo(null)}
           
            
          >
            <div  style={{borderRadius: '10%'}}>
             "Some information"
              <a
                target="_new"
                href={`http://en.wikipedia.org/w/index.php?title=Special:Search&search=$Brovary`}
              >
                Wikipedia
              </a>
            </div>
         
          </Popup>
        )} */}


  </Map>
        </Col>

        <Col xs={5}>
        
 
        <form style={{ marginTop:'2%'}} onSubmit={handleSubmit(onSubmit)}>
            <div class="mb-3">
                <label class="form-label" for="title">Title</label>
                <input class="form-control" type="text" id="title"  {...register("title")} name="campground[title]" required 
                 onChange={(e)=>{
                 setTitle(e.target.value)
                     
                }}
                value={title}
                />
                <div class="valid-feedback">
                    Looks good!
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label" for="location">Location</label>
                <input class="form-control" type="text" {...register("location")} id="location" 
                 onChange={async(event)=>{
                    setLocation(event.target.value)
                    setLocationAddr(event.target.value)
      
                  }}
                  
                  value={location}
                required />
                <div class="valid-feedback">
                    Looks good!
                </div>
            </div>
            <div class="mb-3">
                <button class="btn btn-success"
                type="button"
               
                onClick={
                  async()=>{
                    const res = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${location}.json?access_token=pk.eyJ1Ijoic3R1ZGlncmFkIiwiYSI6ImNsZ25vN3JsazBoazUzbG9ldGlyYnZ0eGMifQ.dJHZGOO-SlBXr70pSXZ3iw`)
                    setMarkes([{long :res.data.features[0].center[0],lat : res.data.features[0].center[1]}])
                      mapRef.current.flyTo({
                        center: [res.data.features[0].center[0], res.data.features[0].center[1]], 
                        duration: 2000,
                        zoom: 10
                    });  
                  }
                }
                >Find</button>
            </div>
            <div class="mb-3">
            <label class="form-label" for="description">Choose country</label>
      
            <Form.Select aria-label="Default select example"
            {...register("country")}
             value={selectValue} 
             onChange={handleChange} 
             required
            >
                <option>Select country</option>
               
                { countries.map((el)=>(
            <option value={el}>{el}</option> 
                )
                      
                )}
            </Form.Select>

            
              </div>
              <div class="mb-3">
              <label class="form-label" for="description">Choose type</label>
              <Form.Select aria-label="Default select example" 
              {...register("org_type")}
              value={org_type} 
              onChange={handleChangeOrg} 
              required
              >
                <option>Open this select menu</option>
                <option value="volunteer">Volunteer organization</option>
                <option value="veterinary">Veterinary clinic</option>
                <option value="shop">Animal shops</option>
                <option value="inspection">Departments of border inspection control</option>
              </Form.Select>
              </div>
            <div class="mb-3">
                <label class="form-label" for="description">Description</label>
                <textarea class="form-control" type="text" rows="10" {...register("info")} id="description" name="campground[description]"
                    required
                
                    onChange={(e)=>{
                      setInfo(e.target.value)
                          
                     }}
                     value={info}

                    ></textarea>
                <div class="valid-feedback">
                    Looks good!
                </div>
            </div>
            <div class="mb-3">
                <div class="form-file custom-file">
                <input type="file" class="form-control" id="customFile" name="file" {...register("file")} />    
                    <label class="form-file-label" for="image">
                        <span class="form-file-text custom-file-label">Choose image ...</span>
                   
                    </label>
                </div>
            </div>
            <div class="mb-3">
                <button class="btn btn-success"
                type="submit"
                // onClick={addOrganization}
                >Add Organization</button>
            </div>
        
            </form>
  
        </Col>
      </Row>
          

           




    </Container>
   
    </div>

    );
}

export default Organizations;